import { z } from "zod";

// All any().nullable() fields are defined like this just because
// Backoffice asks for every fields in order to update the partner address.
// So, instead of hard typing and risking to break the request, I'd rather
// prefer to type these fields as any as they are not really important for our
// usage. That's the raw optitime response

export const sitePartnerAddressDtoSchema = z.object({
  city: z.string().nullable(),
  cityComplement: z.string().nullable(),
  country: z.string().nullable(),
  degradation: z.string().nullable(),
  geocodingType: z.string().nullable(),
  initialAddress: z.any().nullable(),
  latitude: z.any().nullable(),
  locality: z.any().nullable(),
  longitude: z.any().nullable(),
  number: z.string().nullable(),
  postalCode: z.string().nullable(),
  score: z.any().nullable(),
  selectedEntity: z.any().nullable(),
  state: z.any().nullable(),
  street: z.string().nullable(),
  streetComplement: z.string().nullable(),
});

export type TSitePartnerAddressDto = z.infer<typeof sitePartnerAddressDtoSchema>;
